/**
 * ============================================================
 * KEJJA OS — src/AdminApp.tsx (v2)
 * ============================================================
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLoginPage from '@/pages/admin/AdminLoginPage';
import AdminLayout from '@/pages/admin/AdminLayout';
import AdminOverviewPage from '@/pages/admin/AdminOverviewPage';
import AdminUsersPage from '@/pages/admin/AdminUsersPage';
import AdminHomesPage from '@/pages/admin/AdminHomesPage';
import AdminSystemPage from '@/pages/admin/AdminSystemPage';
import AdminEmailsPage from '@/pages/admin/AdminEmailsPage';
import AdminAdminsPage from '@/pages/admin/AdminAdminsPage';

export default function AdminApp() {
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminOverviewPage />} />
        <Route path="users"  element={<AdminUsersPage />} />
        <Route path="homes"  element={<AdminHomesPage />} />
        <Route path="admins" element={<AdminAdminsPage />} />
        <Route path="system" element={<AdminSystemPage />} />
        <Route path="emails" element={<AdminEmailsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  );
}
